'use es6';

import { ACTION_HUB_OPT_IN, ACTION_HUB_OPT_OUT, ACTION_USER_OPT_OUT } from 'ui-addon-opt/state/OptActions';
import AdditionalOptionsPropType from './AdditionalOptionsPropType';
import { BetaButton } from './BetaButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultOptOutButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "ui-addon-opt.optout.label"
});
const Optout = ({
  additionalOptions,
  dispatch,
  learnMore,
  onFeedbackSurveyClick = emptyFunction,
  onLearnMoreClick = emptyFunction,
  onMinimized = emptyFunction,
  onView = emptyFunction,
  optOutButtonText = defaultOptOutButtonText,
  showFeedbackSurvey = false,
  showHubOptin = false,
  showHubOptout = false,
  showUserOptout = true
}) => {
  return /*#__PURE__*/_jsx(Dropdown, {
    Button: BetaButton,
    buttonText: optOutButtonText,
    onOpenComplete: onView,
    "data-test-id": "dropdown",
    children: /*#__PURE__*/_jsxs(List, {
      wrapChildren: true,
      children: [showUserOptout && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_USER_OPT_OUT
        }),
        "data-test-id": "userOptoutButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optout.options.userOptout"
        })
      }), showHubOptout && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_HUB_OPT_OUT
        }),
        "data-test-id": "hubOptoutButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optout.options.hubOptout"
        })
      }), showHubOptin && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_HUB_OPT_IN
        }),
        "data-test-id": "hubOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.hubOptin"
        })
      }), learnMore && /*#__PURE__*/_jsx(Button, {
        href: learnMore.url,
        onClick: onLearnMoreClick,
        target: "_blank",
        "data-test-id": "learnMoreButton",
        children: learnMore.text
      }), showFeedbackSurvey && /*#__PURE__*/_jsx(Button, {
        onClick: onFeedbackSurveyClick,
        "data-test-id": "submitFeedbackButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optout.options.submitFeedback"
        })
      }), additionalOptions && additionalOptions.map(({
        text,
        onClick
      }, idx) => /*#__PURE__*/_jsx(Button, {
        onClick: onClick,
        "data-test-id": `additionalOptionsButton${idx}`,
        children: text
      }, `option-${idx}`)), /*#__PURE__*/_jsx(Button, {
        onClick: onMinimized,
        "data-test-id": "minimizeButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.common.options.minimize"
        })
      })]
    })
  });
};
Optout.propTypes = {
  additionalOptions: AdditionalOptionsPropType,
  dispatch: PropTypes.func.isRequired,
  learnMore: PropTypes.shape({
    text: PropTypes.node.isRequired,
    url: PropTypes.string.isRequired
  }),
  onFeedbackSurveyClick: PropTypes.func,
  onLearnMoreClick: PropTypes.func,
  onMinimized: PropTypes.func,
  onView: PropTypes.func,
  optOutButtonText: PropTypes.node,
  showFeedbackSurvey: PropTypes.bool,
  showHubOptin: PropTypes.bool,
  showHubOptout: PropTypes.bool,
  showUserOptout: PropTypes.bool
};
export default Optout;